import { Button, Box, Skeleton } from "@mui/material";
import { AddBox, Pageview, RestartAlt, Search } from "@mui/icons-material";

const GridFilter = ({ data, handleSubmit, newItemUrl, children, title }) => {
  return (
    <div className="SearchBar">
      {data.isLoading ? (
        <>
          <Skeleton height={45} />
          <Skeleton height={45} />
        </>
      ) : (
        <Box component="form" noValidate onSubmit={handleSubmit}>
          {title && (
            <div className="w-full flex items-center gap-2 mb-3 border-b pb-1">
              <Pageview fontSize="medium" color="primary" />
              <h4
                lang="tr"
                className="w-full text-base text-black text-opacity-75"
              >
                {title}
              </h4>
            </div>
          )}
          {children}
          <div className="w-full flex items-center justify-end gap-4">
            <div className="flex items-center">
              <Button
                startIcon={<Search fontSize="large" />}
                size="small"
                type="submit"
                fullWidth
                variant="contained"
                lang={"tr"}
              >
                Arama Yap
              </Button>
            </div>
            <div className="flex items-center">
              <Button
                startIcon={<RestartAlt fontSize="large" />}
                size="small"
                fullWidth
                variant="contained"
                color="info"
                href={window.location.href}
                lang={"tr"}
              >
                Temizle
              </Button>
            </div>
            {newItemUrl && (
              <div className="flex items-center">
                <Button
                  endIcon={<AddBox fontSize="large" />}
                  size="small"
                  href={newItemUrl}
                  fullWidth
                  variant="contained"
                  color="success"
                  lang={"tr"}
                >
                  Yeni Kayıt Ekle
                </Button>
              </div>
            )}
          </div>
        </Box>
      )}
    </div>
  );
};

export default GridFilter;
